export type ContentPlanAccessMode = 'admin' | 'all';

export const CONTENT_PLAN_ACCESS_MODE: ContentPlanAccessMode = 'admin';

export function isContentPlanAdminOnly(): boolean {
  return CONTENT_PLAN_ACCESS_MODE === 'admin';
}

export function canAccessContentPlan({
  isAdmin,
  hasBillingAccess = false,
}: {
  isAdmin: boolean;
  hasBillingAccess?: boolean;
}): boolean {
  return CONTENT_PLAN_ACCESS_MODE === 'all' || isAdmin || hasBillingAccess;
}
